

// export default function Paginacion({ articulos, handlePreviousPage, page, totalArticulos, itemsPerPage, handleNextPage }) {
//     return (
//         <>
//             {/* Controles de paginación */}
//             {articulos?.length > 0 && (

//                 <div className='flex justify-center items-center mt-5 mb-4'>
//                     <button
//                         onClick={handlePreviousPage}
//                         className='font-semibold border border-black px-2 py-1 rounded-full mr-2 bg-red-500 w-24 text-white cursor-pointer'
//                         disabled={page === 1}
//                     >
//                         Anterior
//                     </button>
//                     <span className='font-semibold text-white'>Página {page} de {Math.ceil(totalArticulos / itemsPerPage)}</span>
//                     <button
//                         onClick={handleNextPage}
//                         className='font-semibold border border-black px-2 py-1 rounded-full ml-2 bg-blue-500 w-24 text-white cursor-pointer'
//                         disabled={page === Math.ceil(totalArticulos / itemsPerPage)}
//                     >
//                         Siguiente
//                     </button>
//                 </div>
//             )}
//         </>
//     )
 
// }

export default function Paginacion({ articulos, handlePreviousPage, page, totalArticulos, itemsPerPage, handleNextPage }) {
    const totalPages = Math.ceil(totalArticulos / itemsPerPage);

    return (
        <>
            {/* Controles de paginación */}
            {articulos?.length > 0 && (
                <div className='flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-2 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:mx-auto sm:max-w-md lg:max-w-xs lg:rounded-xl lg:p-1.5'>

                    {/* Botón Anterior */}
                    <button
                        onClick={handlePreviousPage}
                        className={`
                            flex h-11 items-center justify-center gap-1.5 rounded-xl px-3.5 text-sm font-semibold transition sm:px-4 lg:h-8 lg:gap-1 lg:rounded-lg lg:px-2.5 lg:text-xs
                            ${page === 1
                                ? 'cursor-not-allowed text-slate-300 dark:text-slate-600'
                                : 'text-slate-700 hover:bg-slate-100 active:scale-95 dark:text-slate-200 dark:hover:bg-slate-800'}
                        `}
                        disabled={page === 1}
                        aria-label="Página anterior"
                    >
                        <svg className="h-5 w-5 lg:h-4 lg:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                        <span>Anterior</span>
                    </button>

                    {/* Indicador de página */}
                    <p className='text-sm text-slate-500 dark:text-slate-400 lg:text-xs'>
                        <span className='font-semibold tabular-nums text-slate-900 dark:text-white'>{page}</span>
                        <span className='mx-1'>de</span>
                        <span className='font-semibold tabular-nums text-slate-900 dark:text-white'>{totalPages}</span>
                    </p>

                    {/* Botón Siguiente */}
                    <button
                        onClick={handleNextPage}
                        className={`
                            flex h-11 items-center justify-center gap-1.5 rounded-xl px-3.5 text-sm font-semibold transition sm:px-4 lg:h-8 lg:gap-1 lg:rounded-lg lg:px-2.5 lg:text-xs
                            ${page === totalPages
                                ? 'cursor-not-allowed bg-slate-100 text-slate-300 dark:bg-slate-800 dark:text-slate-600'
                                : 'bg-brand-600 text-white shadow-sm hover:bg-brand-700 active:scale-95'}
                        `}
                        disabled={page === totalPages}
                        aria-label="Página siguiente"
                    >
                        <span>Siguiente</span>
                        <svg className="h-5 w-5 lg:h-4 lg:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            )}
        </>
    );
}
